module.exports = __webpack_public_path__ + "static/media/Laser Mech.ee56815a.jpg";